export default "__VITE_ASSET__0C8YyJkh__"